<template>
  <div v-rect-loading="loading" class="employee-sync-detail-container">
    <NoBorderTable
      class="table"
      :showCreateBtn="false"
      :noOperation="true"
      :tableColumns="tableColumns"
      :listData="displayList"
      :rowClassName="tableRowClassName"
    >
    </NoBorderTable>
    <el-pagination
      class="pagination"
      background
      layout="total, sizes, prev, pager, next"
      :total="pageInfo.total"
      :page-count="pageInfo.page"
      :page-size="pageInfo.pageSize"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
      >
    </el-pagination>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import NoBorderTable from '@/components/tableList/noBorderTable.vue'

export default {
  components: {
    NoBorderTable
  },
  props: {
    historyId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.apScheduler',
      loading: false,
      dataList: [],
      displayList: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.dialog.atsEmployeeId`),
          dataKey: 'ats_employee_id'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.employeeId`),
          dataKey: 'employee_id'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.employeeName`),
          dataKey: 'employee_name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.employeeEmail`),
          dataKey: 'employee_email'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.syncStatus`),
          dataKey: 'sync_status',
          formatter: (data, row) => {
            if (!row.is_deleted && data) {
              return this.$t(`${this.i18nPrefix}.recordStatus.${data}`)
            }
            return ''
          }
        }
      ]
    }
  },
  created () {
    this.initDataList()
  },
  methods: {
    ...mapActions('apScheduler', ['getEmployeeSyncDetailInfoByHistoryId']),
    async initDataList () {
      this.loading = true
      try {
        const resp = await this.getEmployeeSyncDetailInfoByHistoryId(this.historyId)
        if (resp) {
          this.dataList = resp
          this.handlePageChange(1)
        }
      } finally {
        this.loading = false
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'gray-background'
      }
    },
    handlePageChange (val) {
      this.loading = true
      const dataList = this.dataList
      try {
        this.pageInfo.page = val
        const startIndex = (this.pageInfo.page - 1) * this.pageInfo.pageSize
        if (dataList) {
          this.pageInfo.total = dataList.length
          this.displayList = dataList.slice(startIndex, startIndex + this.pageInfo.pageSize)
        }
      } finally {
        setTimeout(() => {
          this.loading = false
        }, 200)
      }
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.handlePageChange(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.employee-sync-detail-container {
  ::v-deep .el-table {
    border: 0px;

    .el-table__header {
      .el-table__cell {
        font-size: 14px;
        padding: 20px 0;
        color: #000000;
        font-weight: 600;

        &.is-leaf {
          background-color: #FFFFFF;
        }
      }
    }

    .el-table__body {
        .el-table__cell {
          padding: 20px 0;

          .cell {
            padding: 0 5px;
          }
        }

        .gray-background {
          background: #f7f7f7;
        }
    }
  }

  .pagination {
    text-align: right;
    margin-right: 10px;
    padding: 10px;
  }
}
</style>
